import request from '@/router/axios';

//修改配置资源表资源显示顺序
export const updateConfigResourcesShowOrder = (data) => {
  return request({
    url: '/svolt-ess-boss-service/common/updateConfigResourcesShowOrder',
    method: 'post',
    data: data
  })
}

export default{
  updateConfigResourcesShowOrder
}



// WEBPACK FOOTER //
// ./src/api/common.js